import * as icons from '../../assets/icons';
import * as permissions from '../../config/permissions';
import { isImpersonating } from '../../utils';

const menu = [
  {
    title: 'Home',
    path: '/growz/dashboard',
    icon: icons.HomeIcon,
    menuId: 1,
  },
  {
    title: 'Products',
    path: '/growz/products',
    icon: icons.ProductsIcon,
    permission: permissions.PERM_GROWZ_PRODUCT_VIEW,
    menuId: 2,
  },
  // {
  //   title: 'Analytics',
  //   path: '/growz/analytics',
  //   icon: icons.AnalyticsIcon,
  //   permission: permissions.PERM_GROWZ_ANALYTICS_VIEW,
  // },
  {
    path: '/growz/recommendation',
    title: 'Recommendation',
    icon: icons.RecommendationIcon,
    permission: permissions.PERM_GROWZ_ANALYZE_SCREEN_ACCESS,
    menuId: 7,
  },
  {
    title: 'Reports',
    path: '/growz/reports/dashboard',
    icon: icons.OverviewIcon,
    menuId: 3,
    hasNestedMenu: true,
    menu: [
      {
        title: 'Back to Home',
        path: '/growz/dashboard',
        icon: icons.BackIcon,
        permission: permissions.PERM_GROWZ_ANALYTICS_VIEW,
        isMainMenu: true,
        menuId: 0,
      },
      {
        title: 'Overview',
        path: '/growz/reports/dashboard',
        icon: icons.HomeIcon,
        heading: 'Reports',
      },
      {
        title: 'Comparison',
        path: '/growz/reports/comparison',
        icon: icons.CompareIcon,
        permission: permissions.PERM_GROWZ_PRODUCT_VIEW,
      },
      {
        title: 'Placement Report',
        path: '/growz/reports/placement-reports',
        icon: icons.OverviewIcon,
        permission: permissions.PERM_GROWZ_ANALYTICS_VIEW,
      },
      {
        title: 'Campaigns',
        path: '/growz/reports/store-campaign',
        icon: icons.CampaignsIcon,
        permission: permissions.PERM_GROWZ_ANALYTICS_VIEW,
        heading: 'Store Level reports',
      },
      {
        title: 'Product Ads',
        path: '/growz/reports/store-product-ads',
        icon: icons.ProductsIcon,
        permission: permissions.PERM_GROWZ_ANALYTICS_VIEW,
      },
      {
        title: 'Keywords',
        path: '/growz/reports/store-keyword',
        icon: icons.KeywordsIcon,
        permission: permissions.PERM_GROWZ_ANALYTICS_VIEW,
      },
      {
        title: 'Targets',
        path: '/growz/reports/store-targets',
        icon: icons.ProductsIcon,
        permission: permissions.PERM_GROWZ_ANALYTICS_VIEW,
      },
      {
        title: 'Search Term',
        path: '/growz/reports/store-search-term',
        icon: icons.SearchtermIcon,
        permission: permissions.PERM_GROWZ_ANALYTICS_VIEW,
      },
      {
        title: 'Placements',
        path: '/growz/reports/store-placement',
        icon: icons.OverviewIcon,
        permission: permissions.PERM_GROWZ_ANALYTICS_VIEW,
      },
      {
        title: 'Brand Metrics',
        path: '/growz/reports/brand-metrics',
        icon: icons.OverviewIcon,
        permission: permissions.PERM_GROWZ_ANALYTICS_VIEW,
      },
    ],
    permission: permissions.PERM_GROWZ_ANALYTICS_VIEW,
  },
  {
    title: 'Campaigns',
    path: '/growz/campaigns',
    icon: icons.CampaignsIcon,
    permission: permissions.PERM_GROWZ_ALL_CAMPAIGNS_VIEW,
    menuId: 4,
  },
  {
    title: 'Strategies',
    path: '/growz/strategy/launched?menu=true',
    icon: icons.StrategiesIcon,
    permission: permissions.PERM_GROWZ_MICROGOALS_VIEW,
    menuId: 5,
  },
  {
    path: '/growz/rank-tracker',
    title: 'Rank Tracker',
    icon: icons.RankTracker,
    permission: permissions.PERM_GROWZ_RANK_TRACKER_TOOL_ACCESS,
    menuId: 8,
  },
  {
    path: '/growz/keyword',
    title: 'Keywords',
    icon: icons.KeywordsIcon,
    permission: permissions.PERM_GROWZ_KEYWORD_TOOL_ACCESS,
    menuId: 6,
  },
  {
    title: 'ASIN Analyzer',
    path: '/growz/asin/sp/structure',
    icon: icons.SearchtermIcon,
    menuId: 10,
    beta: true,
    hasNestedMenu: true,
    menu: [
      {
        title: 'Back to Home',
        path: '/growz/dashboard',
        icon: icons.BackIcon,
        permission: permissions.PERM_GROWZ_ANALYTICS_VIEW,
        isMainMenu: true,
        menuId: 0,
      },
      {
        title: 'SP Structure FIx',
        path: '/growz/asin/sp/structure',
        icon: icons.CompareIcon,
      },
      {
        title: 'SD Structure FIx',
        path: '/growz/asin/sd/structure',
        icon: icons.CompareIcon,
      },
      {
        title: 'SB Structure FIx',
        path: '/growz/asin/sb/structure',
        icon: icons.CompareIcon,
      },
      {
        title: 'ASIN Search Terms',
        path: '/growz/asin/search-term-report',
        icon: icons.SearchtermIcon,
      },
    ],
  },
  ...(isImpersonating()
    ? [
        {
          path: '/growz/audit-reports',
          title: 'Admin',
          icon: icons.AmzRecoIcon,
          permission: permissions.PERM_GROWZ_ALL_CAMPAIGNS_VIEW,
          menuId: 999,
          hasNestedMenu: true,
          menu: [
            {
              title: 'Back to Home',
              path: '/growz/dashboard',
              icon: icons.BackIcon,
              isMainMenu: true,
              menuId: 0,
            },
            {
              path: '/growz/audit-reports',
              title: 'Audit Reports',
              icon: icons.AmzAdManagerIcon,
              permission: permissions.PERM_GROWZ_ALL_CAMPAIGNS_VIEW,
              menuId: 11,
            },
            {
              path: '/growz/campaign-launcher',
              title: 'Campaign Launcher',
              icon: icons.AmzRecoIcon,
              permission: permissions.PERM_GROWZ_ALL_CAMPAIGNS_VIEW,
              menuId: 12,
            },
            {
              title: 'Creatives',
              path: '/growz/creative',
              icon: icons.OverviewIcon,
              permission: permissions.PERM_GROWZ_MICROGOALS_VIEW,
              menuId: 5,
            },
          ],
        },
      ]
    : []),
];

export default menu;
